// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-container[data-v-481a2460] {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
/* 第一行：系统图标 + 一级菜单 + 下拉框 */
.layout-header[data-v-481a2460] {
  height: 28px;
  background: #f2f2f2;
  color: #000;
  z-index: 1000;
  padding: 0;
  border-bottom: 1px solid #ccc;
}
.layout-header .header-content[data-v-481a2460] {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}
.layout-header .header-left[data-v-481a2460] {
  display: flex;
  align-items: center;
}
.layout-header .header-left .system-logo[data-v-481a2460] {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667eea;
  font-size: 16px;
  font-weight: bold;
}
.layout-header .header-left .system-logo i[data-v-481a2460] {
  font-size: 20px;
}
.layout-header .header-center[data-v-481a2460] {
  flex: 1;
  display: flex;
  justify-content: flex-start;
}
.layout-header .header-center .top-menu[data-v-481a2460] {
  background: unset;
  height: 100%;
  border: unset;
}
.layout-header .header-center .top-menu .el-menu-item[data-v-481a2460] {
  height: 100%;
  margin: 0 2px;
  font-weight: 500;
  font-size: 14px;
  line-height: unset;
  border: unset;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-self: unset;
  color: #000;
  padding: 0 12px;
}
.layout-header .header-center .top-menu .el-menu-item[data-v-481a2460]:hover {
  background: #ebffff;
}
.layout-header .header-center .top-menu .el-menu-item.is-active[data-v-481a2460] {
  border: unset;
  background: #c4edff;
}
.layout-header .header-right[data-v-481a2460] {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.layout-header .header-right label[data-v-481a2460] {
  font-size: 14px;
  font-weight: 600;
}
.layout-header .header-right .lock-no[data-v-481a2460] {
  margin-left: 16px;
}
.layout-header .header-right .el-select[data-v-481a2460] {
  width: 300px;
  color: #000;
}
.layout-header .header-right .el-select[data-v-481a2460] .el-input__inner {
  color: unset;
}
/* 第二行：二级菜单 */
.submenu-bar[data-v-481a2460] {
  height: 40px;
  padding: 0 16px;
  background: #f2f2f2;
  color: #000;
  z-index: 1000;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.submenu-bar .submenu[data-v-481a2460] {
  background: transparent;
  border-bottom: none;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #000;
}
.submenu-bar .submenu .el-menu-item[data-v-481a2460] {
  height: 100%;
  margin: 0 2px;
  font-weight: 500;
  font-size: 14px;
  line-height: unset;
  border: unset;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-self: unset;
  color: #000;
  padding: 0 12px;
}
.submenu-bar .submenu .el-menu-item[data-v-481a2460]:hover {
  background: #ebffff;
}
.submenu-bar .submenu .el-menu-item.is-active[data-v-481a2460] {
  border: unset;
  background: #c4edff;
}
.submenu-bar .submenu-right[data-v-481a2460] {
  font-size: 14px;
  font-weight: 600;
}
/* 第三行：内容区域 */
.layout-content[data-v-481a2460] {
  flex: 1;
  overflow-y: auto;
  background: #fff;
  padding: 12px 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout.vue","webpack://./Layout.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;ACAF;AACA,0BAA0B;ADG1B;EACE,YAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,6BAAA;ACDF;ADLA;EASI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;ACDJ;ADZA;EAiBI,aAAA;EACA,mBAAA;ACFJ;ADhBA;EAqBM,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;ACFN;AD1BA;EA+BQ,eAAA;ACFR;AD7BA;EAqCI,OAAA;EACA,aAAA;EACA,2BAAA;ACLJ;ADlCA;EA0CM,iBAAA;EACA,YAAA;EACA,aAAA;ACLN;ADvCA;EA+CQ,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;ACLR;ADOQ;EACE,mBAAA;ACLV;ADQQ;EACE,aAAA;EACA,mBAAA;ACNV;AD7DA;EA0EI,aAAA;EACA,mBAAA;EACA,yBAAA;ACVJ;ADlEA;EA+EM,eAAA;EACA,gBAAA;ACVN;ADtEA;EAoFM,iBAAA;ACXN;ADzEA;EAwFM,YAAA;EACA,WAAA;ACZN;AD7EA;EA4FQ,YAAA;ACZR;AACA,aAAa;ADkBb;EACE,YAAA;EAGA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AClBF;ADOA;EAcI,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EAEA,WAAA;ACnBJ;ADFA;EAwBM,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;ACnBN;ADqBM;EACE,mBAAA;ACnBR;ADsBM;EACE,aAAA;EACA,mBAAA;ACpBR;ADxBA;EAkDI,eAAA;EACA,gBAAA;ACvBJ;AACA,aAAa;AD2Bb;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;ACzBF","sourcesContent":["\n.layout-container {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 第一行：系统图标 + 一级菜单 + 下拉框 */\n.layout-header {\n  height: 28px;\n  background: #f2f2f2;\n  color: #000;\n  z-index: 1000;\n  padding: 0;\n  border-bottom: 1px solid #ccc;\n\n  .header-content {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 16px;\n  }\n\n  .header-left {\n    display: flex;\n    align-items: center;\n\n    .system-logo {\n      width: 32px;\n      height: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #667eea;\n      font-size: 16px;\n      font-weight: bold;\n\n      i {\n        font-size: 20px;\n      }\n    }\n  }\n\n  .header-center {\n    flex: 1;\n    display: flex;\n    justify-content: flex-start;\n\n    .top-menu {\n      background: unset;\n      height: 100%;\n      border: unset;\n\n      .el-menu-item {\n        height: 100%;\n        margin: 0 2px;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: unset;\n        border: unset;\n        height: 32px;\n        border-radius: 6px;\n        display: flex;\n        align-items: center;\n        justify-self: unset;\n        color: #000;\n        padding: 0 12px;\n\n        &:hover {\n          background: #c4edff * 1.2;\n        }\n\n        &.is-active {\n          border: unset;\n          background: #c4edff;\n        }\n      }\n    }\n  }\n\n  .header-right {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n\n    label {\n      font-size: 14px;\n      font-weight: 600;\n    }\n\n    .lock-no {\n      margin-left: 16px;\n    }\n\n    .el-select {\n      width: 300px;\n      color: #000;\n\n      ::v-deep .el-input__inner {\n        color: unset;\n      }\n    }\n  }\n}\n\n/* 第二行：二级菜单 */\n.submenu-bar {\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  background: #f2f2f2;\n  color: #000;\n  z-index: 1000;\n  border-bottom: 1px solid #ccc;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  .submenu {\n    background: transparent;\n    border-bottom: none;\n    height: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n\n    color: #000;\n\n    .el-menu-item {\n      height: 100%;\n      margin: 0 2px;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: unset;\n      border: unset;\n      height: 32px;\n      border-radius: 6px;\n      display: flex;\n      align-items: center;\n      justify-self: unset;\n      color: #000;\n      padding: 0 12px;\n\n      &:hover {\n        background: #c4edff * 1.2;\n      }\n\n      &.is-active {\n        border: unset;\n        background: #c4edff;\n      }\n    }\n  }\n\n  .submenu-right {\n    font-size: 14px;\n    font-weight: 600;\n  }\n}\n\n/* 第三行：内容区域 */\n.layout-content {\n  flex: 1;\n  overflow-y: auto;\n  background: #fff;\n  padding: 12px 16px;\n}\n",".layout-container {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n/* 第一行：系统图标 + 一级菜单 + 下拉框 */\n.layout-header {\n  height: 28px;\n  background: #f2f2f2;\n  color: #000;\n  z-index: 1000;\n  padding: 0;\n  border-bottom: 1px solid #ccc;\n}\n.layout-header .header-content {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n}\n.layout-header .header-left {\n  display: flex;\n  align-items: center;\n}\n.layout-header .header-left .system-logo {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #667eea;\n  font-size: 16px;\n  font-weight: bold;\n}\n.layout-header .header-left .system-logo i {\n  font-size: 20px;\n}\n.layout-header .header-center {\n  flex: 1;\n  display: flex;\n  justify-content: flex-start;\n}\n.layout-header .header-center .top-menu {\n  background: unset;\n  height: 100%;\n  border: unset;\n}\n.layout-header .header-center .top-menu .el-menu-item {\n  height: 100%;\n  margin: 0 2px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: unset;\n  border: unset;\n  height: 32px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-self: unset;\n  color: #000;\n  padding: 0 12px;\n}\n.layout-header .header-center .top-menu .el-menu-item:hover {\n  background: #ebffff;\n}\n.layout-header .header-center .top-menu .el-menu-item.is-active {\n  border: unset;\n  background: #c4edff;\n}\n.layout-header .header-right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.layout-header .header-right label {\n  font-size: 14px;\n  font-weight: 600;\n}\n.layout-header .header-right .lock-no {\n  margin-left: 16px;\n}\n.layout-header .header-right .el-select {\n  width: 300px;\n  color: #000;\n}\n.layout-header .header-right .el-select ::v-deep .el-input__inner {\n  color: unset;\n}\n/* 第二行：二级菜单 */\n.submenu-bar {\n  height: 40px;\n  padding: 0 16px;\n  background: #f2f2f2;\n  color: #000;\n  z-index: 1000;\n  border-bottom: 1px solid #ccc;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.submenu-bar .submenu {\n  background: transparent;\n  border-bottom: none;\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  color: #000;\n}\n.submenu-bar .submenu .el-menu-item {\n  height: 100%;\n  margin: 0 2px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: unset;\n  border: unset;\n  height: 32px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-self: unset;\n  color: #000;\n  padding: 0 12px;\n}\n.submenu-bar .submenu .el-menu-item:hover {\n  background: #ebffff;\n}\n.submenu-bar .submenu .el-menu-item.is-active {\n  border: unset;\n  background: #c4edff;\n}\n.submenu-bar .submenu-right {\n  font-size: 14px;\n  font-weight: 600;\n}\n/* 第三行：内容区域 */\n.layout-content {\n  flex: 1;\n  overflow-y: auto;\n  background: #fff;\n  padding: 12px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
